
import { defineComponent } from 'vue';
import MainLayout from '@/layout/MainLayout.vue';
import { useGalleryStore } from '@/store/GalleriesStore';
import { useAuthStore } from '@/store/AuthStore';
import { usePrivateSellersStore } from '@/store/PrivateSellersStore';
import { Data, UserRecord } from '@/dataTypes/types';
import Swal from 'sweetalert2';
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue';

export default defineComponent({
  components: { MainLayout, SpinnerLoader },
  data() {
    const Gallery = useGalleryStore();
    const Auth = useAuthStore();
    const PrivateSeller = usePrivateSellersStore();
    return {
      Gallery,
      PrivateSeller,
      galleryInfo: {} as Data,
      userInfo: {} as UserRecord,
      Auth,
      role: '',
      link: '',
      description: '',
      name: '',
      loader: false,
    };
  },
  computed: {
    currentStore() {
      return this.role === 'gallery' ? this.Gallery : this.PrivateSeller;
    },
    isGalleryOrPrivateSeller() {
      return this.role === 'gallery' || this.role === 'private_seller';
    },
  },
  methods: {
    async handleUpdateInfo(link: string, description: string) {
      this.loader = true;
      const response = await this.currentStore.updateInfo({
        link: link,
        description: description,
      });
      this.loader = false;
      if (response) {
        Swal.fire({
          title: 'Success!',
          text:
            this.role === 'gallery'
              ? 'Gallery info updated'
              : 'Private seller info updated',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#000',
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#000',
        });
      }
    },
    async resetPassword() {
      this.loader = true;
      const message = await this.Auth.resetPassword(this.userInfo?.email);
      this.loader = false;
      if (message) {
        Swal.fire({
          title: 'Success!',
          text: 'Check your email to reset your password',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#000',
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#000',
        });
      }
    },
  },
  async mounted() {
    if (this.Auth.isLoggedIn) {
      this.userInfo = await this.Auth.fetchUserInfo();
      if (this.Auth.userRole === 'gallery') {
        this.galleryInfo = await this.Gallery.getInfo();
        this.name = this.galleryInfo.gallery.title;
        this.link = this.galleryInfo.gallery.link;
        this.description = this.galleryInfo.gallery.description;
      }
      this.role = this.Auth.userRole;
    }
  },
});
